
import { BlogSection } from '@/types/blog';

export const mindsetVeraendernSection: BlogSection = {
  id: 'mindset-veraendern',
  title: 'Wie du dein Geld-Mindset aktiv verändern kannst',
  content: `
    <p>
      Ein gesundes Verhältnis zu Geld bedeutet nicht nur, finanziell kluge Entscheidungen zu treffen, sondern auch, 
      sich emotional von Geldstress zu befreien. Hier sind einige effektive Strategien:
    </p>
    
    <div class="my-8">
      <img 
        src="/images/blog/notizen-planung.jpg" 
        alt="Person macht Notizen in einem Notizbuch - Finanzielle Planung" 
        class="rounded-lg w-full h-auto shadow-md" 
      />
      <p class="text-sm text-center mt-2 text-joerg-600">Regelmäßige Reflexion hilft, Geldgewohnheiten zu erkennen und zu verändern</p>
    </div>
  `
};
